export default __webpack_public_path__ + "static/media/arcade.ce95b05c.mp3";